<template>
  <div>
    <div ref="modal" class="modal fade" :class="{ show: active, 'd-block': active }" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header d-flex align-items-center justify-content-between">
            <!-- Judul Modal -->
            <h5 class="modal-title">History Detail</h5>

            <!-- Wrapper untuk tombol -->
            <div class="d-flex gap-2">
              <!-- Tombol Download -->
              <!-- <button type="button" class="btn btn-sm btn-primary" v-on:click="download()">
                      Download
                  </button> -->

              <!-- Tombol Close -->
              <button type="button" class="btn-close" data-bs-dismiss="modal" v-on:click="$emit('closeModal')"
                aria-label="Close">
              </button>
            </div>
          </div>

          <div class="modal-body">
            <!-- :rows="rows"  -->
            <vue-good-table title="list-order-ct" mode="remote" :totalRows="totalRecords" :line-numbers="true"
              :pagination-options="{
                enabled: true,
              }" :isLoading.sync="isLoading" @on-page-change="onPageChange" @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :columns="log=='no' ? columns_no : columns" :rows="rows">
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  <a style="color: #ab0635; cursor: pointer; " title="Detail" @click.prevent="
                    detailData(props.index, props.row)
                    ">
                    <i class="mdi mdi-eye" style="font-size:16px"></i>

                  </a>
                </span>
              </template>
            </vue-good-table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="$emit('closeModal')">
              cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <modal-driver-fullfilment-detail :showModal="showModalDetail" :data="dataSend"
      @closeModal="closeMyModalDetail"></modal-driver-fullfilment-detail> -->
  </div>
</template>

<script>
// import modalDriverFullfilmentDetail from "@/components/modal/modalDriverFullfilmentDetail.vue";

export default {
  components: {
    // "modal-driver-fullfilment-detail": modalDriverFullfilmentDetail
  },
  name: "modalDetialHistory",
  emits: ["closeModal", "pushData"],
  props: {
    showModal: Boolean,
    data: null,
    log: null,
  },
  watch: {
    showModal: {
      handler(newVal) {
        this.active = newVal;
        const body = document.querySelector("body");
        this.showModal
          ? body.classList.add("modal-open")
          : body.classList.remove("modal-open");
          console.log(this.data.m_p2h_answer_id);
        if (this.showModal == true) {
          this.loadItems(this.data.m_p2h_answer_id, this.log);
        }

      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      dataSend: {},
      showModalDetail: false,
      closeMyModal: true,
      isLoading: false,
      opens: "center",
      active: this.showModal,
      fetchCompany: [],
      openModalDetail: false,
      totalRecords: 0,
      forms: [],
      status: "ASSIGNED",
      columns: [
        {

          label: "Action",
          field: "action",
          sortable: false,
        },


        {
          label: 'Retake Count',
          field: "retake",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },



        {
          label: 'P2H Name',
          field: "p2h_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Load ID",
          field: "load_id",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: 'Completed Date',
          field: "completed_date",
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy h:mm:ss a',//'dd MMM yyyy',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "NMK Driver",
          field: "nmk_driver",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // ipick_plannitial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Vehicle No",
          field: "vehicle_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: 'Type Truck',
          field: "type_truck",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Type Truck", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


      ],


      columns_no: [
        {

          label: "Action",
          field: "action",
          sortable: false,
        },


       
        {
          label: 'P2H Name',
          field: "p2h_name",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "Load ID",
          field: "load_id",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },

        {
          label: 'Completed Date',
          field: "completed_date",
          type: 'date',
          dateInputFormat: 'yyyy-MM-dd HH:mm:ss',
          dateOutputFormat: 'dd MMM yyyy h:mm:ss a',//'dd MMM yyyy',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: "NMK Driver",
          field: "nmk_driver",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // ipick_plannitial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },
        {
          label: "Vehicle No",
          field: "vehicle_no",
          sortable: false,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By ", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


        {
          label: 'Type Truck',
          field: "type_truck",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter By Type Truck", // placeholder for filter input
            filterValue: "", // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            trigger: "enter", //only trigger on enter not on keyup
          },
        },


      ],

      serverParams: {
        columnFilters: {},
        sort: {
          field: "",
          type: "",
        },
        page: 1,
        per_page: 10,
      },
      permision_role: [],
      rows: []
    }
  },
  methods: {




    loadItems(id, log) {
      this.isLoading = true;
      let baseURI=this.$settings.endPoint + `/control-tower/transport-order-header/historylist-p2h-checklist/${id}?log=yes`;
      if(log=='no'){
        baseURI = this.$settings.endPoint + `/control-tower/transport-order-header/historylist-p2h-checklist/${id}?log=no`;
      }
      
      //const baseURI = this.$settings.endPointMPR + "control-tower/transport-order-header";

      return this.$http
        .get(
          baseURI +
          `&limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&p2h_name=${this.serverParams.columnFilters.p2h_name}&load_id=${this.serverParams.columnFilters.load_id}&nmk_driver=${this.serverParams.columnFilters.nmk_driver}&vehicle_no=${this.serverParams.columnFilters.vehicle_no}&type_truck=${this.serverParams.columnFilters.type_truck}&completed_date=`,
          { timeout: 10000 }
        )
        .then((response) => {
          this.rows = response.data.datas;
          this.totalRecords = response.data.datas.total;

          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
      if (this.permision_role.method_custom3) {
        this.loadItems(this.data.m_p2h_answer_id, this.log);
      } else {
        console.log("You don't have permission to access this feature : Method Custom 3");
      }
    },
    onColumnFilter(params) {
      params.page = 1;
      this.updateParams(params);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params[0].type,
          field: params[0].field,
        },
      });
    },

    onPerPageChange(params) {
      this.updateParams({ per_page: params.currentPerPage });
    },



    showImage(imageUrl) {
      this.$swal({
        title: "Preview Image",
        imageUrl: imageUrl,
        imageAlt: "Answer Image",
        imageWidth: '80%', // biar responsive
        imageHeight: 'auto',
        showCloseButton: true,
        width: '50vw', // popup lebih besar
        customClass: {
          image: 'swal2-large-image'
        },
        backdrop: true,
      });
    },

    detailData(index, row) {


      this.isLoading = true;
      const baseURI = this.$settings.endPoint + `/control-tower/transport-order-header/historydetail-p2h-checklist/${row.m_p2h_answer_id}?log=${this.log}&created_at=${row.created_at}`;
      //const baseURI = this.$settings.endPointMPR + "control-tower/transport-order-header";

      return this.$http
        .get(
          baseURI +
          `&limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}`,
          { timeout: 10000 }
        )
        .then((response) => {
          console.log(response.data.datas);

          const datas = response.data.datas;
          // Generate tabel HTML dari datas
          let tableHTML = `
                        <div style="overflow:auto; max-height:400px;">
                        <table border="1" cellpadding="6" cellspacing="0" style="width:100%; border-collapse: collapse; text-align:left; font-size:13px;">
                         <thead style="background:#f2f2f2;">
                            <tr>
                            <th style="width:10px;">Page</th>
                            <th style="width:10px;">Order</th>
                            <th style="width:60px;max-width:60px;">Question</th>
                            <th style="width:10px;">Control Type</th>
                            <th style="width:10px;max-width:60px;">Answer</th>
                            <th style="width:10px;">Outcome</th>
                            </tr>
                        </thead>
                        <tbody>
                    `;

          datas.forEach(item => {
            const question = item.question_detail?.question || '';
            const page = item.question_detail?.page || '';
            const order = item.question_detail?.order || '';
            const controlType = item.control_type;
            const outcome = item.outcome_detail;

            let answer = '';
            if (controlType === 'photo') {
              answer = `
                <img src="${item.answer}" alt="photo" style="max-height:200px; max-width:200px; cursor:pointer;color:#1c1616;" class="preview-image" data-url="${item.answer}" />
              `;
            } else {
              answer = item.answer;
            }
            tableHTML += `
                        <tr>
                            <td>${page}</td>
                            <td>${order}</td>
                            <td>${question}</td>
                            <td>${controlType}</td>
                            <td>${answer}</td>
                            <td>${outcome}</td>
                        </tr>
                        `;
          });

          tableHTML += '</tbody></table></div>';

          // Tampilkan SweetAlert
          this.$swal({
            title: 'Detail P2H Checklist',
            html: tableHTML,
            width: '80%',
            customClass: {
              popup: 'swal-wide'
            },
            confirmButtonText: 'Tutup',
            didOpen: () => {
              const imgs = document.querySelectorAll('.preview-image');
              imgs.forEach(img => {
                img.addEventListener('click', () => {
                  const url = img.getAttribute('data-url');
                  this.showImage(url);
                });
              });
            }
          });
          // this.rows = response.data.datas;
          // this.totalRecords = response.data.datas.total;

          this.isLoading = false;
        }).catch(error => {
          this.isLoading = false;
          if (error.code == "ECONNABORTED") {
            this.error(this.$t("check_internet_connection_txt"));
          } else {

            if (error.response) {
              if (error.response.status === 422) {
                this.errors = error.response.data.errors;
                this.resultError(error.response.data.errors);
              } else if (error.response.status === 500) {
                this.$router.push('/server-error');
              } else if (error.response.status === 401) {
                this.$router.push("/authorized-error");
              } else {
                this.$router.push('/page-not-found');
              }
            }

          }

        });

    },

    closeMyModalDetail() {
      this.showModalDetail = false;
    },
    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.detailUser = userDatas.sub;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == "MprDashboardController") {
          rolePermision = permision;
        }
      });
      this.permision_role = rolePermision;
    }

  },
  mounted() {
    this.fetchIt();
  },
}
</script>

<style scoped>
.modal {
  background: rgba(0, 0, 0, 0.4);
}

.modal-content {
  background: #fff;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  padding: 0px;
  width: 100%;
  height: 100%;
  margin-left: 0px !important;
}
</style>